<script setup>
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import SuggestionServices from "@/api/services/suggestion.service";
import moment from "moment";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/app/stores/authStore";

const router = useRouter();
const authStore = useAuthStore();

const optionsStatus = ref([]);
const suggestions = ref([]);
const status = ref('');
const page = ref(1);
const itemsPerPage = ref(10);
const totalResults = ref(0);

onMounted(() => {
  getStatus();
  filterSuggestions();
})

const search = () => {
  page.value = 1;
  filterSuggestions();
}

const filterSuggestions = () => {
  const user = authStore.getUserLogged;
  const params = {
    itemsPerPage: itemsPerPage.value,
    page: page.value,
    'order[timestamp]': 'DESC',
  }
  if (status.value) {
    params['suggestionStatus.name'] = status.value;
  }
  SuggestionServices.getSuggestionsAsAuthor(user.id, params)
    .then((resp) => {
      suggestions.value = resp.data['hydra:member'];
      totalResults.value = resp.data['hydra:totalItems'] || 0;
    })
}
const getStatus = () => {
  SuggestionServices.getStatus({ itemsPerPage: 9999, page: 1 })
    .then((resp) => {
      optionsStatus.value = resp.data['hydra:member'];
    })
}
const newSuggestion = () => {
  router.push("/createsuggestion");
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format("DD/MM/YYYY");
  }
  return "";
}
</script>

<template>
  <div>
    <header-title title="MisSugerencias" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/speaker-icon.svg" width="50" alt="">
      <div class="title-text ml-4">
        SUGERENCIAS
      </div>
    </div>
    <el-row>
      <el-card class="card-search w-100" body-style="padding:0">
        <div class="my-suggestions-search">
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="d-flex flex-nowrap flex-column mt-4 w-100 label-common">
                <div class="form-item">
                  <label for="id-status" class="w-100">Estado</label>
                  <el-select v-model="status" class="search-input w-100" color="light" filterable clearable
                    placeholder="Todos" @change="search">
                    <el-option v-for="item in optionsStatus" :key="item.id" :label="item.name" :value="item.name" />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 d-flex mt-5 pr-5 justify-content-end align-items-center">
              <div class="my-suggestions-actions">
                <button class="btn btn_red btn-search" @click="newSuggestion()">
                  NUEVA
                </button>
                <button class="btn btn_yellow btn-search ml-4" @click="search()">
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </el-row>
    <el-row>
      <div class="table table-users table-not-mobile">
        <table v-if="suggestions && suggestions.length">
          <thead>
            <tr>
              <th>
                <div class="d-flex justify-content-start align-items-center gap-2">
                  <img src="@/assets/icons/calendar-icon.svg" width="20" height="20" alt="calendar-icon" />
                  <div class="ml-4">
                    FECHA
                  </div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center gap-2">
                  <img src="@/assets/icons/speaker-icon.svg" width="20" height="20" alt="calendar-icon" />
                  <div>TITULO</div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center gap-2">
                  <img src="@/assets/icons/speaker-icon.svg" width="20" height="20" alt="calendar-icon" />
                  <div>AREA DE MEJORA</div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center gap-2">
                  <img src="@/assets/icons/speaker-icon.svg" width="20" height="20" alt="calendar-icon" />
                  <div>ESTADO</div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="sugg in suggestions" :key="sugg.id">
              <td>
                <div class="link-name">
                  <router-link :to="{ name: 'suggestions-update', params: { id: sugg.id } }">
                    {{ formatDate(sugg.timestamp) }}
                  </router-link>
                </div>
              </td>
              <td>
                <div class="link-name">
                  <router-link :to="{ name: 'suggestions-update', params: { id: sugg.id } }">
                    {{ sugg.title }}
                  </router-link>
                </div>
              </td>
              <td>
                <span v-if="sugg.department && sugg.department.name">{{ sugg.department.name }}</span>
              </td>
              <td>
                <span v-if="sugg.suggestionStatus && sugg.suggestionStatus.name">{{ sugg.suggestionStatus.name }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="mt-3">
          <p class="alert alert-info">No tiene sugerencias actualmente</p>
        </div>
      </div>
      <div class="table-mobile w-100">
        <div v-if="suggestions && suggestions.length">
          <el-row v-for="sugg in suggestions" :key="sugg.id" class="mt-3">
            <el-card class="my-suggestion-mobile-card w-100">
              <div class="my-suggestion-mobile-card__header">
                <router-link class="my-suggestion-mobile-card__title"
                  :to="{ name: 'suggestions-update', params: { id: sugg.id } }">
                  {{ sugg.title }}
                </router-link>
              </div>
              <div class="my-suggestion-mobile-card__item">
                <span><b class="my-suggestion-mobile-card__label">Fecha:</b>
                  {{ formatDate(sugg.timestamp) || '--' }}</span>
              </div>
              <div class="my-suggestion-mobile-card__item">
                <span> <b class="my-suggestion-mobile-card__label">Area de mejora: </b>
                  {{ sugg.department?.name || '--' }}</span>
              </div>
              <div class="my-suggestion-mobile-card__item">
                <span><b class="my-suggestion-mobile-card__label">Estado:</b>
                  {{ sugg.suggestionStatus?.name || '--' }}</span>
              </div>
            </el-card>
          </el-row>
        </div>
        <div v-else class="mt-3">
          <p class="alert alert-info">No tiene sugerencias actualmente</p>
        </div>
      </div>
    </el-row>
    <SharedElementPagination
      class="pagination"
      v-model:current-page="page"
      v-model:page-size="itemsPerPage"
      :total="totalResults"
      @change="filterSuggestions"
      show-always
    />
  </div>
</template>

<style lang="scss" scoped>
.btn-search {
  &.btn_yellow {
    color: $bg-blue;
  }

  &.btn_red {
    color: white;
  }

  font-weight: bolder;
  text-transform: uppercase;
  width: 200px;
  height: 40px;
}

.label-common {
  label {
    font-size: 20px;
    font-weight: 800;
    letter-spacing: -2px;
  }
}

.card-search {
  border-radius: 15px;
  height: 150px;
  background: url("../../assets/icons/altavoz.png"), white;
  background-repeat: no-repeat;
  background-position-x: 100%;
  overflow: visible !important;
}

.my-suggestions-search {
  padding: 0 2rem 1rem;
}

#icon-search {
  fill: $bg-blue;
  width: 6%;
}

#icon-search-calendar {
  fill: $bg-blue;
  width: 20px;
  height: 20px;
}

.title-text {
  text-align: center;
  align-self: center;
  font-size: 3em;
  font-weight: 900;
  letter-spacing: -0.05em;
  color: $font-blue-color;
}

.my-suggestions-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-mobile {
  display: none;
}

.my-suggestion-mobile-card {
  border-radius: 18px;
}

.my-suggestion-mobile-card :deep(.el-card__body) {
  padding: 18px 18px 20px;
}

.my-suggestion-mobile-card__header {
  margin-bottom: 14px;
}

.my-suggestion-mobile-card__title {
  color: $bg-blue;
  font-size: 18px;
  font-weight: 800;
  text-decoration: none;
  word-break: break-word;
}

.my-suggestion-mobile-card__item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 10px;
  word-break: break-word;
}

.my-suggestion-mobile-card__label {
  color: $bg-blue;
  font-weight: 800;
}

.table-users {
  table {
    thead {
      tr {
        th {
          padding: 0px !important;
          margin: 0px !important;
        }
      }

      #icon-search {
        fill: $bg-blue;
        width: 2.9em;
      }

      #icon-user {
        fill: $bg-blue;
        width: 1.6em;
      }
    }

    tbody {
      td {
        .link-name {
          margin: auto;
          margin-left: 10px;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media (max-width: 767px) {
  .title-text {
    font-size: 2.2em;
  }

  .card-search {
    height: auto;
    padding: 20px 16px;
    background-size: 92px;
    background-position: calc(100% + 16px) 12px;
  }

  .my-suggestions-search {
    padding: 0;
  }

  .my-suggestions-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    margin-top: 12px;
  }

  .btn-search {
    width: 100%;
    margin-left: 0 !important;
  }

  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    display: block;
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
